<template>
  <div>
    <!-- 服务商 -->
    <div class="detail-wrap">
      <el-form ref="editForm" :model="formData">
        <div class="d-header">
          <div class="fl">
            <i class="el-icon-info"/>
            申请单号：<span v-if="formData.applyNo" style="font-weight: 600;color: #2196f3;margin-right: 5px;">{{
              formData.applyNo
            }}</span>
            <span v-else class="information"> 待生成</span>
            <!-- 状态 -->
            <span class="information">
              {{
                formData.stat == '0' ? '制单' : formData.stat == '1' ? '申请' : formData.stat == '2' ? '审核' : formData.stat ==
                '3' ? '已发货' : formData.stat == '4' ? '已收货' : formData.stat == '9' ? '驳回' : formData.stat == '98' ? '已结算' :
                  '取消'
              }}</span>

          </div>
          <div style="display:none">

            <el-button type="primary" plain class="button-sty" @click="$baseReload()" icon="el-icon-thumb">指派中心
            </el-button>
            <el-button type="primary" plain class="button-sty" @click="$baseReload()" icon="el-icon-chat-line-square">
              用户催单
            </el-button>
            <el-button type="primary" plain class="button-sty" @click="$baseReload()" icon="el-icon-tickets">工单跟进
            </el-button>
            <el-button type="primary" plain class="button-sty" @click="$baseReload()" icon="el-icon-document-delete">
              关闭工单
            </el-button>
            <el-button type="primary" plain class="button-sty" @click="$baseReload()" icon="el-icon-document-copy">打印工单
            </el-button>


          </div>
          <div class="fr" v-show="btn_no">
            <el-button type="primary" class="button-sty" icon="el-icon-check" v-if="((parts_apply_add && formData.id == null)
              || (parts_apply_edit && formData.id != null))
              && (formData.stat == 0 || formData.stat == 9 || (formData.stat == 1 && !currentIsSite))"
                       @click="saveData">保存
            </el-button>
            <el-button type="primary" class="button-sty" icon="el-icon-check"
                       v-if="parts_apply_commit && formData.id != null && formData.stat == 0"
                       @click="showCommitDialog = true">提交审核
            </el-button>
            <el-button type="primary" class="button-sty" icon="el-icon-s-claim"
                       v-if="formData.stat == 1 && parts_apply_audit" @click="showExamineDialog = true">审核
            </el-button>
            <el-button type="primary" class="button-sty" icon="el-icon-refresh-right"
                       v-if="formData.stat == 1 && parts_apply_rejected"
                       @click="() => { showCloseDialog = true; closeType = '驳回' }">驳回
            </el-button>
            <el-button type="primary" class="button-sty" icon="el-icon-close" v-if="(formData.stat == 0 || formData.stat == 9)
              && parts_apply_cancel && formData.id != null"
                       @click="() => { showCloseDialog = true; closeType = '取消' }">取消
            </el-button>

            <el-button type="primary" class="button-sty" icon="el-icon-check"
                       v-if="formData.stat == 2 && parts_apply_outbound && !enablePartsCollect"
                       @click="showOutboundDialog = true">发货
            </el-button>

            <el-button type="primary" class="button-sty" icon="el-icon-check"
                       v-if="formData.stat == 3 && parts_apply_inbound" @click="showInboundDialog = true">收货
            </el-button>

            <el-button type="primary" class="button-sty" icon="el-icon-check" v-if="(formData.stat == 3 || formData.stat == 2 || formData.stat == 3)
              && parts_apply_delivery && enablePartsCollect && formData.collectStat != 2"
                       @click="showDeliveryDialog = true">交货
            </el-button>

            <el-button type="primary" class="button-sty" icon="el-icon-check" v-if="formData.stat == 3 && parts_apply_deliver_no
              && (formData.deliverNo === null || formData.deliverNo === '0' || formData.deliverNo === 0)"
                       @click="showSetDeliverNoDialog = true">物流单号
            </el-button>
            <el-button type="primary" class="button-sty" icon="el-icon-check"
                       v-if="formData.collectStat == 1 && parts_apply_change_collect"
                       @click="showChangeCollectDialog = true">完全交货
            </el-button>
            <el-button type="primary" class="button-sty" icon="el-icon-close"
                       v-if="formData.stat == 2 && formData.collectStat == 0 && parts_apply_interrupt"
                       @click="showInterruptDialog = true">订单中断
            </el-button>
            <!--            <el-button type="primary" class="button-sty" icon="el-icon-close"-->
            <!--                       v-if="formData.stat == 2 && parts_apply_stop"-->
            <!--                       @click="showCloseDialog = true">中止-->
            <!--            </el-button>-->
          </div>
        </div>

        <div>

          <!-- 基本信息 -->
          <dix style="display: flex;  overflow: unset!important;
    overflow-y: scroll!important;
    height: 100vh!important; ">
            <div class="d-cont edit-mce-box" :style=" orderBlock ? 'width:80%': 'width:99%'">
              <div class="d-item">
                <!-- <div class="title first"><b>业务信息</b></div> -->
                <table class="table-detail" style="width: 100%;">
                  <tbody style="width: 100%;">

                  <template>
                    <el-tabs v-model="activeName2" style="width: 100%;" class="gather">
                      <el-tab-pane label="业务信息" name="first">

                        <tr>
                          <th>
                            <em class="f-red">*</em>
                            订单类型
                          </th>
                          <td v-if="justShow || formData.stat >= 1">
                            {{
                              formData.orderType == 1 ? '收费订单' : formData.orderType == 2 ? '记帐订单' : formData.orderType ==
                              3 ? '免费订单' : ''
                            }}
                          </td>
                          <td v-else>
                            <el-form-item>
                              <el-select v-model="formData.orderType" style="width:14vw  ;" @change="loadPartsBalance" s
                                         clearable>
                                <el-option label="收费订单" :value="1"/>
                                <el-option label="记帐订单" :value="2"/>
                                <el-option label="免费订单" :value="3" v-if="!currentIsSite"/>
                              </el-select>
                            </el-form-item>
                          </td>

                          <th>
                            <em class="f-red">*</em>
                            计划类型
                          </th>
                          <td v-if="justShow || formData.stat >= 1">
                            {{ formData.planType == 1 ? '计划内' : formData.planType == 2 ? "计划外" : '' }}
                          </td>
                          <td v-else>
                            <el-form-item>
                              <el-select v-model="formData.planType" style="width:14vw  ;" @change="planTypeChange"
                                         clearable>
                                <el-option label="计划内" :value="1"/>
                                <el-option label="计划外" :value="2"/>
                              </el-select>
                            </el-form-item>
                          </td>

                          <!--                    <th>-->
                          <!--                      费用类型-->
                          <!--                    </th>-->
                          <!--                    <td v-if="justShow">-->
                          <!--                      {{ formData.feeType == 1 ? '现金购买' : formData.feeType == 2 ? '额度申购' : '' }}-->
                          <!--                    </td>-->
                          <!--                    <td v-else>-->
                          <!--                      <el-form-item>-->
                          <!--                        <el-select v-model="formData.feeType" style="width:  ;" clearable>-->
                          <!--                          <el-option label="现金购买" :value="1"/>-->
                          <!--                          <el-option label="额度申购" :value="2"/>-->
                          <!--                        </el-select>-->
                          <!--                      </el-form-item>-->
                          <!--                    </td>-->

                          <th>
                            申请类型
                          </th>
                          <td v-if="justShow">
                            {{
                              formData.applyType == 1 ? "储备订单" : formData.applyType == 2 ? "加急单" : formData.applyType == 3
                                ? '非常规' : formData.applyType == 4 ? "延时申请" : ''
                            }}
                          </td>
                          <td v-else>
                            <el-form-item>
                              <el-select v-model="formData.applyType"  clearable>
                                <el-option label="储备订单" :value="1"/>
                                <el-option label="加急单" :value="2"/>
<!--                                <el-option label="非常规" :value="3"/>-->
<!--                                <el-option label="延时申请" :value="4"/>-->
                              </el-select>
                            </el-form-item>
                          </td>

                          <th>
                            <em class="f-red">*</em>
                            物资类型
                          </th>
                          <td v-if="justShow || formData.stat >= 1">
                            {{ formData.itemType == 1 ? '维修物资' : formData.itemType == 2 ? '非维修物资' : '' }}
                          </td>
                          <td v-else>
                            <el-form-item>
                              <el-select v-model="formData.itemType" @change="() => {
                                  this.formData.spPartsApplyLineDTOList = []
                                }"  clearable>
                                <el-option label="维修物资" :value="1"/>
                                <el-option label="非维修物资" :value="2"/>
                              </el-select>
                            </el-form-item>
                          </td>
                        </tr>
                        <tr>
                          <th>
                            <em class="f-red">*</em>
                            机构名称
                          </th>
                          <td v-if="justShow || currentIsSite || formData.stat >= 1">{{ formData.orgName }}</td>
                          <td v-else>
                            <org-search :org-name.sync="formData.orgName"
                                        :org-id-path.sync="formData.orgIdPath"
                                        :org-id.sync="formData.orgId"
                                        @change="() => {
                                            formData.siteId = null
                                            formData.siteName = null
                                            formData.outWarehouseId = null
                                            formData.outWarehouseName = null
                                            loadOutWarehouse()
                                          }"
                            />
                          </td>

                          <th>
                            <em class="f-red">*</em>
                            网点
                          </th>
                          <td v-if="justShow || currentIsSite || formData.stat >= 1">{{ formData.siteName }}</td>
                          <td v-else>
                            <site-pop-search :site-id.sync="formData.siteId"
                                             :site-name.sync="formData.siteName"
                                             :org-name.sync="formData.orgName"
                                             :org-id-path.sync="formData.orgIdPath"
                                             :org-id.sync="formData.orgId"
                                             :param="{siteFloorLevel: 1}"
                                             @valueChange="getSiteData"/>
                          </td>
                          <th>
                            <em class="f-red">*</em>
                            发出类型
                          </th>
                          <td v-if="justShow && formData.outType == 1 || formData.stat >= 1">总部</td>
                          <td v-else-if="justShow && formData.outType == 2 || formData.stat >= 1">中心</td>
                          <td v-else>
                            <el-form-item>
                              <el-select v-model="formData.outType" @change="() => {
                                  formData.outWarehouseId = null
                                  formData.outWarehouseName = null
                                  formData.spPartsApplyLineDTOList = []
                                  formData.outWarehouseId = null
                                  formData.outWarehouseName = null
                                  loadOutWarehouse()
                                }" clearable>
                                <el-option label="总部" :value="1"/>
                                <el-option label="中心" :value="2"/>
                              </el-select>
                            </el-form-item>
                          </td>

                          <th>
                            <em class="f-red">*</em>
                            出库仓
                          </th>
                          <td v-if="justShow || formData.stat >= 1">{{ formData.outWarehouseName }}</td>
                          <td v-else>
                            <el-select :disabled="currentIsSite" v-model="formData.outWarehouseId" @click.native="() => {
                                if (!formData.orgId) {
                                  $message.error('请先选中机构')
                                }
                              }">
                              <el-option v-for="item in outWarehouseList" :key="item.id" :label="item.warehouseName"
                                         :value="item.id">
                              </el-option>
                            </el-select>
                            <!--                      <el-input type="text"-->
                            <!--                                autocomplete="off"-->
                            <!--                                v-model="formData.outWarehouseName"-->
                            <!--                                clearable :readonly="true">-->
                            <!--                        <i slot="suffix" class="el-input__icon el-icon-search"-->
                            <!--                           @click="showWarehousePop=true"></i>-->
                            <!--                      </el-input>-->
                          </td>


                        </tr>
                        <tr>

                          <th>申请备注</th>
                          <td v-if="justShow">{{ formData.remark }}</td>
                          <td v-else colspan="3">
                            <el-input type="text" autocomplete="off" v-model="formData.remark" clearable>
                            </el-input>
                          </td>

                          <th>
                            <em class="f-red">*</em>
                            运费方式
                          </th>
                          <td v-if="justShow || formData.stat >= 1">
                            {{ formData.domesticShippingType == 1 ? '总部包邮' : formData.domesticShippingType == 2 ? '自付运费' : '' }}
                          </td>
                          <td v-else>
                            <el-form-item>
                              <el-select v-model="formData.domesticShippingType"  clearable>
                                <el-option label="总部包邮" :value="1"/>
                                <el-option label="自付运费" :value="2"/>
                              </el-select>
                            </el-form-item>
                          </td>


                          <th>
                            <em class="f-red">*</em>
                            发货单价格
                          </th>
                          <td v-if="justShow || formData.stat >= 1">
                            {{ formData.applyAmountIsPrint == 1 ? '打印' : formData.applyAmountIsPrint == 2 ? '不打印' : '' }}
                          </td>
                          <td v-else>
                            <el-form-item>
                              <el-select v-model="formData.applyAmountIsPrint"  clearable>
                                <el-option label="打印" :value="1"/>
                                <el-option label="不打印" :value="2"/>
                              </el-select>
                            </el-form-item>
                          </td>
                        </tr>
                      </el-tab-pane>
                      <el-tab-pane label="配送信息" name="two">
                        <tr>


                          <th>收货人姓名</th>
                          <td v-if="justShow">{{ formData.deliverMan }}</td>
                          <td v-else>
                            <el-input type="text" autocomplete="off" v-model="formData.deliverMan"
                                      clearable/>
                          </td>

                          <th>收货人电话</th>
                          <td v-if="justShow">{{ formData.deliverMobile }}</td>
                          <td v-else>
                            <el-input type="text" autocomplete="off" v-model="formData.deliverMobile"
                                      clearable/>
                          </td>


                          <th style="visibility: hidden;"></th>
                          <td>
                            <el-button v-if="!justShow" type="primary" class="button-sty btn_zdy"
                                       style="margin-left: -70px !important;"
                                       @click="$refs.siteAddressDialog.dialogShow()">
                              地址信息
                            </el-button>
                          </td>
                          <th style="visibility: hidden;"></th>
                          <td></td>

                        </tr>
                        <tr>
                          <th>
                            地区
                          </th>
                          <td v-if="justShow" colspan="3">
                            {{ formData.deliverProvince }}{{ formData.deliverCity }}{{
                              formData.deliverCounty
                            }}{{ formData.deliverTown }}
                          </td>
                          <td v-else colspan="3">
                            <el-form-item>
                              <template>
                                <el-cascader :props="areaProps" v-model="areaValues" :clearable="true"
                                             style="width:100%;" @change="handleChange" ref="cascader"
                                             :options="areaOption">
                                </el-cascader>
                              </template>
                            </el-form-item>
                          </td>

                          <th>
                            详细地址
                          </th>
                          <td v-if="justShow" colspan="3">{{ formData.deliverAddress }}</td>
                          <td v-else colspan="3">
                            <el-input type="text" autocomplete="off" v-model="formData.deliverAddress" clearable/>
                          </td>
                        </tr>
                        <tr v-if="!enablePartsCollect">
                          <th>配送方式名称</th>
                          <td>{{ formData.deliverTypeName }}</td>

                          <th>物流公司名称</th>
                          <td>{{ formData.deliverCompanyName }}</td>

                          <th>物流单号</th>
                          <td >
                              <span v-if="formData.deliverNo != null && formData.deliverNo != 0"
                                    style="color: blue; cursor:pointer;" @click="showDeliverNoForOther()">
                                {{ formData.deliverNo }}
                              </span>
                          </td>


                          <th style="visibility: hidden;"></th>
                          <td></td>
                        </tr>
                        <div style="height: 10px;"></div>
                        <tr>
                          <th>
                            发货状态
                          </th>
                          <td v-if="formData.outStat == 0">未发货</td>
                          <td v-else-if="formData.outStat == 1">部分发货</td>
                          <td v-else-if="formData.outStat == 2">完全发货</td>
                          <td v-else></td>


                          <th>
                            收货状态
                          </th>
                          <td v-if="formData.getStat == 0">未收货</td>
                          <td v-else-if="formData.getStat == 1">部分收货</td>
                          <td v-else-if="formData.getStat == 2">完全收货</td>
                          <td v-else></td>

                          <th>外部单号</th>
                          <td>{{ formData.outOrderNo }}</td>

                          <th>交货状态</th>
                          <td v-if="formData.collectStat == 0">未交货</td>
                          <td v-else-if="formData.collectStat == 1">部分交货</td>
                          <td v-else-if="formData.collectStat == 2">完全交货</td>
                          <td v-else></td>
                        </tr>
                      </el-tab-pane>
                      <el-tab-pane label="处理过程" name="third" v-if="formData.id">
                        <tr>
                          <th>
                            申请时间
                          </th>
                          <td>{{ formData.applyDate }}</td>

                          <th>提交时间</th>
                          <td>{{ formData.commitDate }}</td>

                          <th>审核人</th>
                          <td>{{ formData.checkBy }}</td>

                          <th>审核时间</th>
                          <td>{{ formData.checkDate }}</td>
                        </tr>
                        <tr>
                          <th>发货人</th>
                          <td>{{ formData.outBy }}</td>

                          <th>发货时间</th>
                          <td>{{ formData.outDate }}</td>

                          <th>收货人</th>
                          <td>{{ formData.getBy }}</td>

                          <th>收货时间</th>
                          <td>{{ formData.getDate }}</td>
                        </tr>
                        <tr>
                          <th>驳回人</th>
                          <td>{{ formData.rejectBy }}</td>

                          <th>驳回时间</th>
                          <td>{{ formData.rejectDate }}</td>

                          <th>取消时间</th>
                          <td>{{ formData.cancelDate }}</td>

                          <th>打印次数</th>
                          <td>{{ formData.printNum }}</td>
                        </tr>
                        <tr>
                          <th>物流时间</th>
                          <td>{{ formData.writeDeliverDate }}</td>
                        </tr>
                      </el-tab-pane>
                      <el-tab-pane label="关联交货单&物流信息" name="fourth">
                        <div class="product" style="">

                          <vxe-table style="margin-top: 0px;" :stripe="true"
                                     :header-cell-style="{ height: '30px', background: '#EFF6FC',fontWeight:'700',textAlign:'left', padding: '0', borderTop: '1px solid #eaeaea', fontSize: '12px', color: '#808080', width: '95%' }"
                                     :row-config="{ height: 30, isHover: true, padding: 0, }"
                                     :row-style="{ fontSize: '12px', }"
                                     show-overflow height="110" :column-config="{ resizable: true }"
                                     :data="formData.spPartsApplyCollectHeaderDTOList">
                            <!--                            <vxe-column type="checkbox" width="40"/>-->
                            <vxe-column field="collectNo" title="交货单号" width="180">
                              <template #default="{ row }">
                                  <span style="color: blue; cursor:pointer;" @click="showCollect(row)">
                                    {{ row.collectNo }}
                                  </span>
                              </template>
                            </vxe-column>
                            <vxe-column field="stat" width="100" title="状态">
                              <template #default="{ row }">
                                <span v-if="row.stat == 1">待发货</span>
                                <span v-else-if="row.stat == 3">已发货</span>
                                <span v-else-if="row.stat == 99">取消</span>
                              </template>
                            </vxe-column>
                            <vxe-column field="qty" title="数量" width="60"></vxe-column>
                            <vxe-column field="collecter" title="交货人"></vxe-column>
                            <vxe-column field="deliverNo" title="物流单号">
                              <template #default="{ row }">
                                <span v-if="row.deliverNo != null && row.deliverNo != 0"
                                      style="color: blue; cursor:pointer;" @click="showDeliverNo(row)">
                                    {{ row.deliverNo }}
                                </span>
                                <span v-else></span>
                              </template>
                            </vxe-column>
                            <vxe-column field="send1No" title="外部交货单号"></vxe-column>
                            <vxe-column field="send1Flag" title="交货同步状态">
                              <template #default="{ row }">
                                <span v-if="row.send1Flag == 1">失败</span>
                                <span v-else-if="row.send1Flag == 2">已传</span>
                                <span v-else-if="row.send1Flag == 0">未传</span>
                                <span v-else-if="row.send1Flag == 3">取消</span>
                                <span v-else>未传</span>
                              </template>
                            </vxe-column>
                            <vxe-column field="send1Message" title="交货同步备注"></vxe-column>
                            <vxe-column field="createBy" title="创建人"></vxe-column>
                            <vxe-column field="createTime" title="创建时间"></vxe-column>
                            <vxe-column title="操作" width="100">
                              <template #default="{row}">
                                <el-button v-if="row.stat != 99 && parts_apply_collect_cancel"
                                           type="primary" class="button-sty" icon="el-icon-close"
                                           @click="docancle(row.id)">取消
                                </el-button>
                              </template>
                            </vxe-column>
                          </vxe-table>
                        </div>
                      </el-tab-pane>

                      <el-tab-pane label="接口对接" name="five">
                        <tr>
                          <th>ERP销售订单传单备注</th>
                          <td colspan="3">
                            <el-tooltip class="item" effect="dark" :content="this.formData.sendMessage"
                                        placement="top">
                              <span>{{ formData.sendMessage }}</span>
                            </el-tooltip>
                          </td>

                          <th>
                            传单状态
                          </th>
                          <td v-if="formData.sendFlag == 0">未传</td>
                          <td v-else-if="formData.sendFlag == 1">失败</td>
                          <td v-else-if="formData.sendFlag == 2">已传</td>
                          <td v-else-if="formData.sendFlag == 3">取消</td>
                          <td v-else></td>

                          <th>传单号</th>
                          <td>{{ formData.sendNo }}</td>

                          <th>传单时间</th>
                          <td>{{ formData.sendDate }}</td>
                        </tr>
                        <tr>
                          <th>WMS锁库传单备注</th>
                          <td colspan="3">
                            <el-tooltip class="item" effect="dark" :content="this.formData.send1Message"
                                        placement="top">
                              <span>{{ formData.send1Message }}</span>
                            </el-tooltip>
                          </td>

                          <th>
                            传单状态
                          </th>
                          <td v-if="formData.send1Flag == 0">未传</td>
                          <td v-else-if="formData.send1Flag == 1">失败</td>
                          <td v-else-if="formData.send1Flag == 2">已传</td>
                          <td v-else-if="formData.send1Flag == 3">取消</td>
                          <td v-else>未传</td>

                          <th>传单号</th>
                          <td>{{ formData.send1No }}</td>

                          <th>传单时间</th>
                          <td>{{ formData.send1Date }}</td>
                        </tr>
                      </el-tab-pane>

                      <el-tab-pane label="数量&金额" name="six">
                        <tr>
                          <th>
                            总申请数量
                          </th>
                          <td>{{ formData.applyQtyAll }}</td>

                          <th>
                            总申请金额
                          </th>
                          <!-- <td v-if="isSite">*</td> -->

                          <td >{{ formData.applyAmountAll }}</td>

                          <th>总审核数量</th>
                          <td>{{ formData.checkQtyAll }}</td>

                          <th>总审核金额</th>
                          <!-- <td v-if="isSite">*</td> -->

                          <td >{{ formData.checkAmountAll }}</td>
                        </tr>
                        <tr>
                          <th>
                            总发货数量
                          </th>
                          <td>{{ formData.outQtyAll }}</td>

                          <th>总发货金额</th>
                          <!-- <td v-if="isSite">*</td> -->

                          <td >{{ formData.outAmountAll }}</td>

                          <th>总收货数量</th>
                          <td>{{ formData.getQtyAll }}</td>

                          <th>总收货金额</th>
                          <!-- <td v-if="isSite">*</td> -->

                          <td>{{ formData.getAmountAll }}</td>
                        </tr>
                      </el-tab-pane>

                      <el-tab-pane label="图片" name="seven">
                        <tr v-if="!justShow">
                          <th>图片1</th>
                          <td colspan="">
                            <div class="form_picture">
                              <div>
                                <photo-upload :photo-url.sync="formData.pic1"/>
                              </div>
                            </div>
                          </td>
                          <th>图片2</th>
                          <td colspan="">
                            <div class="form_picture">
                              <div>
                                <photo-upload :photo-url.sync="formData.pic2"/>
                              </div>
                            </div>
                          </td>
                          <th>图片3</th>
                          <td colspan="">
                            <div class="form_picture">
                              <div>
                                <photo-upload :photo-url.sync="formData.pic3"/>
                              </div>
                            </div>
                          </td>
                        </tr>
                        <tr v-else>
                          <th>图片</th>
                          <td style="width:24vw !important">
                            <multiplePhotoShow :photo-url-list="[formData.pic1, formData.pic2, formData.pic3]"/>
                          </td>
                        </tr>
                      </el-tab-pane>

                    </el-tabs>
                  </template>


                  </tbody>
                </table>
              </div>

              <div class="d-item">
                <div style="display: flex;justify-content: space-between;flex-wrap: nowrap;">
                  <div class="title first"><b>申请明细</b>
                    <span style="color: #606266 !important; font-weight: 400; font-size: 14px;">记账可用余额：{{
                        totalBalance
                      }}</span>
                    <span style="color: #606266 !important; margin-left: 25px; font-weight: 400; font-size: 14px;">现金可用余额：{{
                        liquidBalance
                      }}</span>
                    <span style="color: #606266 !important; margin-left: 25px; font-weight: 400; font-size: 14px;">
                      最小起订金：{{ formData.minPartsApplyAmount }}
                    </span>
                    <span style="color: #606266 !important; margin-left: 25px; font-weight: 400; font-size: 14px;">
                      加急可用余量：{{ urgerPartsQty }}
                    </span>
                  </div>
                  <div class="item-button" style="margin-top: 8px;">
                    <el-button type="primary" class="button-sty btn_zdy" @click="$refs.excelUpload.show()"
                               v-if="!justShow && formData.planType == 2 && (formData.stat == 0 || formData.stat == 9 || (formData.stat == 1 && !currentIsSite))">
                      <i class="el-icon-plus"></i>
                      导入明细
                    </el-button>&nbsp;
                    <el-button type="primary" class="button-sty btn_zdy" @click="showPartsInvPopFunc('wait')"
                               v-if="!justShow && formData.planType == 2">
                      <i class="el-icon-plus"></i>
                      工单待申请
                    </el-button>
                    &nbsp;<el-button type="primary" class="button-sty btn_zdy" @click="showPartsInvPopFunc('line')"
                                     v-if="!justShow">
                    <i class="el-icon-plus"></i>
                    添加明细
                  </el-button>&nbsp;
                    <el-button v-if="!justShow" type="primary" class="button-sty btn_zdy" @click="deleteData">
                      <i class="el-icon-delete"></i>
                      批量删除
                    </el-button>
                  </div>
                </div>
                <div>
                  <vxe-table style="margin-top: 0px;" :stripe="true"
                             :header-cell-style="{ height: '30px', background: '#EFF6FC', padding: '0', borderTop: '1px solid #eaeaea', fontSize: '12px', color: '#808080', width: '95%' }"
                             :row-config="{ height: 30, isHover: true, padding: 0, }" :row-style="{ fontSize: '12px', }"
                             show-overflow height="500" :column-config="{ resizable: true }"
                             :checkbox-config="{checkMethod: ({row}) => {return row.checkStat != 5  && row.checkStat != 6}}"
                             @checkbox-change="selectChangeEvent"
                             @checkbox-all="selectChangeEvent" :data="formData.spPartsApplyLineDTOList">
                    <vxe-column type="checkbox" width="40"/>
                    <vxe-column field="lineId" title="行号" width="50"/>
                    <vxe-column field="partsCode" title="配件编码" width="120">
                      <template #default="{ row }">
                        <el-input size="small"
                                  v-if="!justShow && row.checkStat != 5 && row.checkStat != 6"
                                  :readonly="true"
                                  @focus="changeParts(row)"
                                  v-model="row.partsCode">
                          <i slot="suffix" class="el-icon-more" @click="changeParts(row)"></i>
                        </el-input>
                        <span v-else>{{ row.partsCode }}</span>
                      </template>
                    </vxe-column>
                    <vxe-column field="partsName" title="配件名称" width="100"></vxe-column>
                    <!--                    <vxe-column field="outWarehouseName" title="发出仓库" width="120"></vxe-column>-->
                    <vxe-column field="userPrice" v-if="this.companyShortName === companyConfig.NIU_EN_TAI" title="零售价" width="60"></vxe-column>
                    <vxe-column field="sitePrice" title="单价" width="60">
                      <template #default="{row}">
                  <span v-if="isSite">*</span>
                  <span v-else>{{ row.sitePrice }}</span>
                </template>
                    </vxe-column>
                    <!--                    <vxe-column field="" title="计划数量" width="70"></vxe-column>-->
                    <vxe-column field="applyQty" title="申请数量" width="70">
                      <template #default="{ row }">
                        <vxe-input size="small"
                                   v-if="!justShow && row.checkStat != 5 && row.checkStat != 6"
                                   v-model="row.applyQty"
                                   type="number"
                                   :min="1"
                                   :max="getApplyQty(row)"
                                   :clearable="false"></vxe-input>
                        <span v-else>{{ row.applyQty }}</span>
                      </template>
                    </vxe-column>
                    <vxe-column field="checkQty" title="审核数量" width="70"></vxe-column>
                    <vxe-column field="collectQty" title="交货数量" width="70"></vxe-column>
                    <vxe-column field="outQty" title="发货数量" width="70"></vxe-column>
                    <vxe-column field="getQty" title="收货数量" width="70"></vxe-column>
                    <vxe-column field="remark" title="申请备注" width="140">
                      <template #default="{row}">
                        <el-input v-if="!justShow" size="small" v-model="row.remark"/>
                        <span v-else>{{ row.remark }}</span>
                      </template>
                    </vxe-column>
                    <vxe-column field="orderNo" title="工单号" width="120">
                      <template #default="{ row }">
                        <el-input size="small" v-if="formData.stat == 0" :readonly="true" @focus="addOrderNo(row)"
                                  v-model="row.orderNo">
                          <i slot="suffix" class="el-icon-more" @click="addOrderNo(row)"></i>
                        </el-input>
                        <span v-else>{{ row.orderNo }}</span>
                      </template>
                    </vxe-column>
                    <!--                    <vxe-column field="planNo" title="计划单号" width=""></vxe-column>-->
                    <vxe-column title="审批状态" width="70">
                      <template #default="{ row }">
                        <span v-if="row.checkStat == 0">待审批</span>
                        <span v-else-if="row.checkStat == 5">已审核</span>
                        <span v-else-if="row.checkStat == 6">不通过</span>
                      </template>
                    </vxe-column>
                    <vxe-column field="checkRemark" title="审批备注" width="140"></vxe-column>
                    <!--                    <vxe-column field="sendFlag"  title="传单状态">-->
                    <!--                      <template #default="{row}">-->
                    <!--                        <span v-if="row.sendFlag == 2">已传</span>-->
                    <!--                        <span v-else-if="row.sendFlag == 1">失败</span>-->
                    <!--                        <sapn v-else>未传</sapn>-->
                    <!--                      </template>-->
                    <!--                    </vxe-column>-->
                    <vxe-column field="getStat" title="收货状态" width="70">
                      <template #default="{ row }">
                        <span v-if="row.getStat == 0">未收货</span>
                        <span v-else-if="row.getStat == 1">部分收货</span>
                        <span v-else-if="row.getStat == 2">完全收货</span>
                      </template>
                    </vxe-column>
                    <vxe-column title="操作" width="70">
                      <template #default="{ row }">
                        <el-tooltip v-if="parts_apply_line_data_release && Number(row.outQty)>0 && (Number(row.collectQty) - Number(row.outQty)) > 0"
                                    class="item" effect="dark" content="锁库释放" placement="top">
                          <el-button type="primary"
                                     plain
                                     size="mini"
                                     @click="releaseData(row.id)"
                                     icon="el-icon-unlock">
                          </el-button>
                        </el-tooltip>
                      </template>
                    </vxe-column>
                  </vxe-table>
                </div>
              </div>


              <div style="height:160px"></div>

            </div>
            <div :style=" orderBlock ? 'width:20%': 'width:1%'" class="bread">
              <div style="padding-bottom: 90px;  height: 100%;  margin-top: 10px; margin-left: 5px;">
                <div style="display: flex;">
                  <div class="title_icon" @click="orderBlock=!orderBlock"><i class="el-icon-date"></i></div>
                  <span :style=" orderBlock ? 'display:block': 'display:none'">申请过程</span>
                </div>
                <el-timeline :style=" orderBlock ? 'display:block': 'display:none'" class="card_bread">
                  <el-timeline-item v-for="item in formData.spPartsApplyOperationDTOList" placement="top">
                    <div class="title_time"><span class="span1">{{ item.title }}</span>
                      <span class="span2">{{ item.createTime }}</span>
                    </div>
                    <el-card class="card">
                      <p>{{ item.content }}</p>
                    </el-card>
                  </el-timeline-item>

                </el-timeline>

              </div>


            </div>


          </dix>

        </div>


      </el-form>
      <!-- 服务区域弹窗表 -->
    </div>
    <warehousePop v-if="showWarehousePop" :warehouseType="warehouseType" @commit="warehouseCommit"
                  :param="{ isOutDefault: 1, dontSite: true }" :visiable.sync="showWarehousePop" multi="true"/>

    <!-- 配件多选 -->
    <partsCheckboxCommonDialog v-if="showPartsInvPop && formData.planType == 2"
                               @confirm="confirm"
                               :param="{
                                 siteId: formData.siteId,
                                 warehouseId: formData.outWarehouseId,
                                 excludePartsIdList: formData.spPartsApplyLineDTOList.filter(item => item.orderId == null).map(item => item.partsId),

                                 costFix: formData.itemType == 1 ? 1 : 0
                               }"
                               :enableSaleStat="true"
                               :visiable.sync="showPartsInvPop"
                               multi="true"
    />

    <!-- 配件待申请 -->
    <partsApplyOrderWaitLineDialog v-if="showPartsWaitPop"
                                   :visiable.sync="showPartsWaitPop"
                                   :param="{
                                      siteId: formData.siteId,
                                      outWarehouseId: formData.outWarehouseId,
                                      excludeData: formData.spPartsApplyLineDTOList.filter(item => item.orderId != null).map(item => {
                                        return { partsId: item.partsId, orderId: item.orderId }
                                      })
                                    }"
                                   @confirm="confirm1"
    />

    <!--配件计划-->
    <parts-apply-plan-in-line-dialog v-if="showPartsInvPop && formData.planType == 1"
                                     :visiable.sync="showPartsInvPop"
                                     :param="{
                                        siteId: formData.siteId,
                                        warehouseId: formData.outWarehouseId,
                                        excludeData: formData.spPartsApplyLineDTOList.map(item => {
                                          return { partsId: item.partsId, planId: item.planId }
                                        })
                                      }"
                                     @confirm="confirm2"
    />

    <!-- <auditDialog v-if="showAuditDialog"
                 :id="formData.id"
                 :visiable.sync="showAuditDialog"
                 multi="true"
                 @goBackIndex="goBackIndex"
    /> -->
    <!-- 新审核 -->
    <examineDialog v-if="showExamineDialog" :id="currentRowId" :visiable.sync="showExamineDialog" multi="true"
                   @goBackIndex="goBackIndex"/>
    <!-- 新出库 -->
    <removalDialog v-if="showOutboundDialog" :id="currentRowId" :visiable.sync="showOutboundDialog" multi="true"
                   @goBackIndex="goBackIndex"/>
    <!-- <outboundDialog v-if="showOutboundDialog"
                    :id="formData.id"
                    :visiable.sync="showOutboundDialog"
                    multi="true"
                    @goBackIndex="goBackIndex"
    /> -->

    <closeDialog v-if="showCloseDialog" :dataId="formData.id" :visiable.sync="showCloseDialog" multi="true"
                 @goBackIndex="goBackIndex" :close-type="closeType"/>

    <commit-dialog v-if="showCommitDialog" :dataId="formData.id" :visiable.sync="showCommitDialog" multi="true"
                   @goBackIndex="goBackIndex"/>

    <inboundDialog v-if="showInboundDialog" :id="formData.id" :visiable.sync="showInboundDialog" multi="true"
                   @goBackIndex="goBackIndex"/>

    <orderPop v-if="showOrderPop" @commit="data => {
      currentRowData.orderId = data.orderId
        currentRowData.orderNo = data.orderNo
    }" :visiable.sync="showOrderPop" :siteId="formData.siteId" :stat-end="21" :businessType="2"
              :unFlash="1"
              multi="true"/>

    <radioPartsDialog v-if="showPartsPop" :visiable.sync="showPartsPop" @commitSelectedRow="data => {
      currentRowData.partsId = data.id; currentRowData.partsCode = data.partsCode;
      currentRowData.partsName = data.partsName; currentRowData.sitePrice = data.sitePrice;
    }"/>

    <!--交货-->
    <delivery-dialog v-if="showDeliveryDialog" :visiable.sync="showDeliveryDialog" :id="formData.id"
                     @goBackIndex="goBackIndex"/>

    <!--交货单详情-->
    <collect-info-dialog v-if="showCollectInfoDialog" @closeD="closeD5" :visiable.sync="showCollectInfoDialog" :data-id="collectId"/>

    <!--物流单号-->
    <setDeliverNoDialog v-if="showSetDeliverNoDialog" :data-id="formData.id" :visiable.sync="showSetDeliverNoDialog"
                        multi="true" @goBackIndex="goBackIndex"/>

    <logistics-information-info-dialog v-if="showLogisticsInformationInfoDialog"
                                       :visiable.sync="showLogisticsInformationInfoDialog"
                                       :formData="logisticsInformationInfo"
    />

    <!--网点地址-->
    <site-address-dialog ref="siteAddressDialog"
                         :site-id="formData.siteId"
                         @commitRow="data => {
                           formData.deliverMan = data.addressMan
                           formData.deliverMobile = data.addressMobile
                           formData.deliverProvince = data.province
                           formData.deliverCity = data.city
                           formData.deliverCounty = data.county
                           formData.deliverTown = data.town
                           formData.deliverAddress = data.address
                           formData.areaId = data.areaId
                           echoAddress()
                         }"
    />

    <!-- 完全交货 -->
    <change-collect v-if="showChangeCollectDialog"
                    :dataId="formData.id"
                    :visiable.sync="showChangeCollectDialog"
                    multi="true"
                    @goBackIndex="goBackIndex"/>

    <!-- 订单中断 -->
    <interrupt-dialog v-if="showInterruptDialog"
                      :dataId="formData.id"
                      :visiable.sync="showInterruptDialog"
                      multi="true"
                      @goBackIndex="goBackIndex"/>

    <!--交货单取消-->
    <collect-cancel-dialog v-if="showCollectCancelDialog"
                           :dataId="formData.cid"
                           :visiable.sync="showCollectCancelDialog"
                           multi="true"
                           @goBackIndex="goBackIndex"/>

    <excel-upload
      ref="excelUpload"
      title="明细批量导入"
      :url="api.spPartsApplyHeader.importLineUrl"
      temp-url="/admin/sys-file/local/file/spPartsApplyLine.xlsx"
      @refreshDataList="importLineData"
    ></excel-upload>
  </div>
</template>

<script>
import store from "@/store";
import api from "@/api/projectApi";
import orderPop from '@/views/dialogCommon/radioOrderDialog.vue'
import warehousePop from '@/views/dialogCommon/radioWarehouseDialog.vue'
import partsInvPop from '@/views/dialogCommon/checkboxPartsInvDialog.vue';
import partsCheckboxCommonDialog from '@/views/dialogCommon/partsCheckboxCommonDialog.vue';
import radioPartsDialog from '@/views/dialogCommon/radioPartsDialog.vue';
import auditDialog from "./auditDialog.vue";
import closeDialog from "./closeDialog.vue";
import commitDialog from "./commitDialog.vue";
import outboundDialog from "./outboundDialog.vue";
import inboundDialog from "./inboundDialog.vue";
import photoUpload from "@/components/formItem/photoUpload.vue"
import partsApplyPlanInLineDialog from "@/views/dialogCommon/partsApplyPlanInLineDialog.vue"
import partsApplyOrderWaitLineDialog from "@/views/dialogCommon/partsApplyOrderWaitLineDialog.vue"
import sitePopSearch from "@/components/formItem/sitePopSearch.vue"
import orgSearch from "@/components/formItem/orgSearch.vue"
import multiplePhotoShow from "@/components/formItem/multiplePhotoShow.vue"
import {mapGetters} from "vuex";
import {editPageMixins, siteMixins} from "@/mixins/tabChang";
// 新审核
import examineDialog from "./examineDialog.vue";
//新出库
import removalDialog from "./removalDialog.vue";
import DeliveryDialog from "@/views/accessories/applyFor/apply/deliveryDialog.vue";
import CollectInfoDialog from "@/views/accessories/applyFor/apply/collectInfoDialog.vue";
import SetDeliverNoDialog from "@/views/accessories/applyFor/apply/setDeliverNoDialog.vue";
import ExcelUpload from "@/components/upload/excel.vue";
import LogisticsInformationInfoDialog from "@/views/accessories/applyFor/apply/logisticsInformationInfoDialog.vue";
import SiteAddressDialog from "@/views/accessories/applyFor/apply/siteAreaDialog.vue";
import ChangeCollect from "@/views/accessories/applyFor/apply/changeCollectDialog.vue";
import InterruptDialog from "@/views/accessories/applyFor/apply/interruptDialog.vue";
import {companyConfig} from "@/config/companyShotName";
import request from "@/router/axios";
import CollectCancelDialog from "@/views/accessories/applyFor/apply/collectCancelDialog.vue";

export default {
  mixins: [editPageMixins, siteMixins],
  name: 'edit',
  props: {
    _dataId: [String, Number],
    editViewType: String,
    btn_no: {
      type: Boolean,
      default: true
    },
  },
  components: {
    CollectCancelDialog,
    InterruptDialog,
    ChangeCollect,
    SiteAddressDialog,
    LogisticsInformationInfoDialog,
    ExcelUpload,
    SetDeliverNoDialog,
    CollectInfoDialog,
    DeliveryDialog,
    photoUpload,
    auditDialog,
    closeDialog,
    outboundDialog,
    inboundDialog,
    orderPop,
    warehousePop,
    partsInvPop,
    partsApplyPlanInLineDialog,
    partsApplyOrderWaitLineDialog,
    sitePopSearch,
    orgSearch,
    multiplePhotoShow,
    commitDialog,
    examineDialog,
    removalDialog,
    partsCheckboxCommonDialog,
    radioPartsDialog
  },
  data() {
    return {
      isSite: false,

      orderBlock: false,
      activeName2: 'first',
      btn_no: true,
      currentRowId: null,
      currentRowData: null,
      showExamineDialog: false,
      parts_apply_add: false,
      parts_apply_edit: false,
      parts_apply_commit: false,
      parts_apply_audit: false,
      parts_apply_cancel: false,
      parts_apply_rejected: false,
      parts_apply_outbound: false,
      parts_apply_inbound: false,
      parts_apply_delivery: false,
      parts_apply_deliver_no: false,
      parts_apply_change_collect: false,
      parts_apply_interrupt: false,
      parts_apply_line_data_release: false,
      parts_apply_collect_cancel: false,
      // parts_apply_stop: false,
      enableBalance: false,  // 配件余额控制
      enablePartsCollect: false,
      closeType: null,
      first: true,
      partsBalance: 0,  // 网点配件余额
      totalBalance:0,
      liquidBalance:0,
      urgerPartsQty:0,//网点可用加急配件申请数
      warehouseType: 0,
      justShow: false,
      showPartsInvPop: false,
      showPartsWaitPop: false,
      showSitePop: false,
      showOrderPop: false,
      showPartsPop: false,
      showDeliveryDialog: false,
      showWarehousePop: false,
      showAuditDialog: false,
      showCommitDialog: false,
      showOutboundDialog: false,
      showInboundDialog: false,
      showCloseDialog: false,
      showOrgDialog: false,
      showSetDeliverNoDialog: false,
      isCancel: false,
      orgOptions: [],
      orgValue: '',
      areaOption: [],
      areaValues: [],
      selectedData: [],
      outWarehouseList: [],
      areaProps: {
        lazy: true,
        checkStrictly: true,
        lazyLoad: this.cascaderLazyLoad
      },
      showPhotoList: [],
      collectId: null,
      showCollectInfoDialog: false,
      showLogisticsInformationInfoDialog: false,
      showChangeCollectDialog: false,
      showInterruptDialog: false,
      showCollectCancelDialog: false,
      logisticsInformationInfo: null,
      maxPartsApplyQty: 0,  // 配件订单最大申请数
      maxPartsApplyAmount:0, //配件订单最大金额
      companyShortName : null,
      formData: {
        cid:null,
        id: null,
        siteName: null,
        outWarehouseName: null,
        remark: null,
        applyNo: null,  // 申请单号;前缀"PA"+年月日+6位流水号
        orgId: 0,  // 所属中心，关联脚手架机构表sys_dept.dept_id
        orgName: null,  // 所属机构名称,冗余字段
        orgIdPath: null,  // 所属机构ID路径,冗余字段.重要
        siteId: null,  // 网点ID,关联sn_user.id;
        stat: 0,  // 单据状态:0制单;1申请;2审核;3已发货;4已收货;9驳回;98已结算;99取消
        orderType: null,
        planType: 2,  // 计划类型:1计划内;2计划外
        outStat: 0,  // 发货状态:0未发货;1部分发货;2完全发货
        getStat: 0,  // 收货状态:0未收货;1部分收货;2完全收货;(只要明细中有一个为部分收货，则表头也为部分收货)
        itemType: 1,  // 物资类型：1维修物资;2非维修物资
        domesticShippingType:1, //运费方式:1总部包邮;2自付运费
        applyAmountIsPrint:null, //是否打印:0打印1不打印
        // feeType: 2,  // 费用类型:1现金购买;2额度申购
        applyType: 1,  // 申请类型：1储备订单;2加急单;3非常规;4延时申请
        outOrderNo: null,  // 外部单号
        outType: 1,  // 发出类型:1总部;2中心
        outWarehouseId: null,  // 出库仓ID,关联bas_warehouse.id
        deliverProvince: null,  // 省
        deliverCity: null,  // 市
        deliverCounty: null,  // 区
        deliverTown: null,  // 街道
        areaId: 0,  // 地区ID,关联bas_area.id
        deliverAddress: null,  // 配件收货人详细地址
        deliverMan: null,  // 配件收货人姓名
        deliverMobile: null,  // 配件收货人电话
        deliverType: null,  // 配送方式ID，关联脚手架数据字典项目表sys_dict_item.id
        deliverTypeName: null,  // 配送方式名称,冗余字段
        deliverCompany: null,  // 物流公司ID，关联脚手架数据字典项目表sys_dict_item.id
        deliverCompanyName: null,  // 物流公司名称,冗余字段
        deliverNo: null,  // 物流单号
        minPartsApplyAmount: 0,
        applyQtyAll: 0,  // 总申请数量
        applyAmountAll: 0,  // 总申请金额
        checkQtyAll: 0,  // 总审核数量
        checkAmountAll: 0,  // 总审核金额
        outQtyAll: 0,  // 总发货数量
        outAmountAll: 0,  // 总发货金额
        getQtyAll: 0,  // 总收货数量
        getAmountAll: 0,  // 总收货金额
        applyDate: null,  // 申请时间
        checkDate: null,  // 审核时间
        checkBy: null,  // 审核人
        outDate: null,  // 发货时间
        outBy: null,  // 发货人
        writeDeliverDate: null,  // 填写物流时间
        getDate: null,  // 收货时间
        getBy: null,  // 收货人
        rejectDate: null,  // 驳回时间
        rejectBy: null,  // 驳回人
        cancelDate: null,  // 取消时间
        printNum: 0,  // 打印次数
        sendFlag: 0,  // 传单状态：0未传;1失败;2已传
        sendDate: null,  // 传单时间
        sendMessage: null,  // 传单备注
        pic1: null,  // 图片1
        pic2: null,  // 图片2
        pic3: null,  // 图片3
        collectStat: null,
        spPartsApplyOperationDTOList: [],
        spPartsApplyLineDTOList: [],
        spPartsApplyCollectHeaderDTOList: []
      },

      show3: false,
      node: true,


      srcList: [],


      isEdit: false,
      tabIndex: 'first',
      dataId: '',


    };
  },
  computed: {
    app(){
      return app
    },
    companyConfig() {
      return companyConfig
    },
    api() {
      return api
    },
    headers: function () {
      const tenantId = store.getters.userInfo.tenantId
      return {
        'Authorization': "Bearer " + store.getters.access_token,
        'TENANT-ID': tenantId
      };
    },
    ...mapGetters(["permissions"])
  },
  created() {
    const userInfo = store.getters.userInfo;
    if (userInfo.snUserId) {
      this.isSite = true;
    }
    this.checkEnableBalance()
    this.parts_apply_add = this.permissions['parts_apply_add']
    this.parts_apply_edit = this.permissions['parts_apply_edit']
    this.parts_apply_commit = this.permissions['parts_apply_commit']
    this.parts_apply_audit = this.permissions['parts_apply_audit']
    this.parts_apply_cancel = this.permissions['parts_apply_cancel']
    this.parts_apply_rejected = this.permissions['parts_apply_rejected']
    this.parts_apply_outbound = this.permissions['parts_apply_outbound']
    this.parts_apply_inbound = this.permissions['parts_apply_inbound']
    this.parts_apply_delivery = this.permissions['parts_apply_delivery']
    this.parts_apply_deliver_no = this.permissions['parts_apply_deliver_no']
    this.parts_apply_change_collect = this.permissions['parts_apply_change_collect']
    this.parts_apply_interrupt = this.permissions['parts_apply_interrupt']
    this.parts_apply_line_data_release = this.permissions['parts_apply_line_data_release']
    this.parts_apply_collect_cancel = this.permissions['parts_apply_collect_cancel']
    // this.parts_apply_stop = this.permissions['parts_apply_stop']

    if (this._dataId && !isNaN(this._dataId)) {
      this.currentRowId = this.dataId = this._dataId
    }
    if (this.btn_no) this.btn_no = this.btn_no;

    if (this.editViewType === 'deliverNo') {
      this.activeName2 = 'fourth'
    } else {
      this.activeName2 = 'first'
    }
  },
  mounted() {
    this.checkEnablePartsCollect()
    this.getData()
    this.getCompanyMsg()
    // console.log('asdfasdk', store.getters.userInfo)
  },
  watch: {
    // 'formData.outType': {
    //   handler(n) {
    //     if (n == 1) {  // 总部
    //       this.warehouseType = 0
    //     } else if (n == 2) {   // 中心
    //       this.warehouseType = 1
    //     }
    //   },
    //   deep: true
    // },
    'formData.spPartsApplyLineDTOList': {
      handler(n) {
        if (n) {
          let temp = 0
          let temp1 = 0
          n.forEach(item => {
            temp += Number(item.applyQty)
            temp1 += Number(item.applyQty) * Number(item.sitePrice)
          })
          this.formData.applyQtyAll = temp
          this.formData.applyAmountAll = Number(temp1).toFixed(2)
        }
      },
      deep: true,
      immediate: false
    }
  },
  methods: {
    closeD5(){
      this.showCollectInfoDialog = false
    },
    docancle(val){
      this.showCollectCancelDialog = true;
      this.formData.cid = val;
    },
    releaseData(id) {
      this.$baseConfirm('您确定要释放库存吗？').then(() => {
        this.$mask.open()
        this.$http.post(api.spPartsApplyHeader.hdReleaseLineDataUrl, {id: id}).then(res => {
          this.$message.success('操作成功')
          this.$mask.close()
        })
      })
    },


    importLineData(data) {
      console.log('导入明细', data)
      // this.formData.spPartsApplyLineDTOList = []
      let f = 1
      data.forEach(item => {
        this.formData.spPartsApplyLineDTOList.push({
          remark: 'excel表格导入',
          partsId: item.partsId,
          partsCode: item.partsCode,
          partsName: item.partsName,
          sitePrice: item.sitePrice,
          applyQty: item.applyQty,
          orderNo: item.orderNo,
          orderId: item.orderId,
          checkQty: 0,
          getQty: 0,
          outQty: 0,
          checkStat: 0,
          getStat: 0,
          selectId: item.partsId + f + Math.floor(Math.random() * 100)
        })
      })
    },

    // 交货单弹窗
    showCollect(row) {
      this.collectId = row.id
      this.showCollectInfoDialog = true
    },

    showDeliverNoForOther() {
      this.$mask.open()
      this.$http.post(api.spPartsApplyHeader.getLogisticsInformationUrl,
        {applyId: this.formData.id,collectId: 1}
      ).then(res => {
        this.logisticsInformationInfo = res.data.data
        this.showLogisticsInformationInfoDialog = true
        this.$mask.close()
      }).catch(() => {
        this.$mask.close()
      })
    },
    // 物流弹窗
    showDeliverNo(row) {
      this.$mask.open()
      this.$http.post(api.spPartsApplyHeader.getLogisticsInformationUrl,
        {applyId: this.formData.id, collectId: row.id}
      ).then(res => {
        this.logisticsInformationInfo = res.data.data
        this.showLogisticsInformationInfoDialog = true
        this.$mask.close()
      }).catch(() => {
        this.$mask.close()
      })
    },

    checkEnablePartsCollect() {
      this.$http.post(api.spPartsApplyHeader.checkEnablePartsCollectUrl, {}).then(res => {
        this.enablePartsCollect = res.data.data
      })
    },

    loadOutWarehouse() {
      if (this.formData.orgId) {
        this.$http.post(api.spPartsApplyHeader.getOutWarehouseUrl, {
          orgId: this.formData.orgId,
          warehouseType: this.formData.outType == 1 ? 0 : 1
        }).then(res => {
          this.outWarehouseList = res.data.data
          if (!this.formData.outWarehouseId) {
            if (this.outWarehouseList.length === 1) {
              this.formData.outWarehouseId = this.outWarehouseList[0].id
            } else {
              let id = null
              this.outWarehouseList.forEach(item => {
                if (item.isOutDefault == 1) {
                  id = item.id
                }
              })
              this.formData.outWarehouseId = id
            }
          }
        })
      } else {
        this.outWarehouseList = []
        this.formData.outWarehouseId = null
      }
    },


    // 方法名称固定，用于当前用户为网点用户时自动设置网点数据
    setSiteData() {
      let siteData = this.currentSiteData;
      this.formData.siteId = siteData.id
      this.formData.siteName = siteData.userName
      this.formData.orgId = siteData.snSiteInfoDTO.orgId
      this.formData.orgName = siteData.snSiteInfoDTO.orgName
      this.formData.orgIdPath = siteData.snSiteInfoDTO.orgIdPath

      this.maxPartsApplyQty = siteData.snSiteInfoDTO.maxPartsApplyQty
      this.maxPartsApplyAmount = siteData.snSiteInfoDTO.maxPartsApplyAmount
      if (!this.maxPartsApplyQty) {
        this.maxPartsApplyQty = 0
      }
      if (!this.maxPartsApplyAmount) {
        this.maxPartsApplyAmount = 0
      }

      this.setDeliverData(siteData)
      // console.log(siteData, 'siteData')
      // this.formData.deliverProvince = siteData.userProvince
      // this.formData.deliverCity = siteData.userCity
      // this.formData.deliverCounty = siteData.userCounty
      // this.formData.deliverTown = siteData.userTown
      // this.formData.deliverAddress = siteData.userAddress
      // this.formData.areaId = siteData.areaId
      // this.echoAddress()

      if (this.formData.planType == 2) {
        this.formData.minPartsApplyAmount = siteData.snSiteInfoDTO.minPartsApplyAmountTwo
      } else {
        this.formData.minPartsApplyAmount = siteData.snSiteInfoDTO.minPartsApplyAmount
      }

      if (!this.formData.minPartsApplyAmount) {
        this.formData.minPartsApplyAmount = 0
      }

      // let siteMan = siteData.snSiteInfoDTO.siteMan
      // if (siteMan != null && siteMan != '') {
      //   this.formData.deliverMan = siteMan
      // } else {
      //   this.formData.deliverMan = siteData.userName
      // }
      // this.formData.deliverMobile = siteData.userMobile

      this.loadPartsBalance()
      this.loadOutWarehouse()
      this.loadUrgerPartsQty()
    },

    getApplyQty: function (row) {
      if (this.formData.planType == 1) {
        return Number(row.availableQty)
      }
      return 9999
    },

    // 计划类型切换
    planTypeChange() {
      this.formData.spPartsApplyLineDTOList = []
      if (this.formData.siteId) {
        if (this.currentIsSite) {
          if (this.formData.planType == 1) {
            this.formData.minPartsApplyAmount = this.currentSiteData.snSiteInfoDTO.minPartsApplyAmount
          } else {
            this.formData.minPartsApplyAmount = this.currentSiteData.snSiteInfoDTO.minPartsApplyAmountTwo
          }
        } else {
          // 带出网点数据
          this.$http.post(api.snUser.getDataUrl, {id: this.formData.siteId}).then(res => {
            let siteData = res.data.data
            if (this.formData.planType == 1) {
              this.formData.minPartsApplyAmount = siteData.snSiteInfoDTO.minPartsApplyAmount
            } else {
              this.formData.minPartsApplyAmount = siteData.snSiteInfoDTO.minPartsApplyAmountTwo
            }
          })
        }
      }
    },

    showPartsInvPopFunc(type) {
      if (this.formData.siteId) {
        if (this.formData.outWarehouseId != null && this.formData.outWarehouseId !== 0) {
          if (type === 'wait') {
            this.showPartsWaitPop = true
          } else
            this.showPartsInvPop = true
        } else {
          this.$message.warning('请先选择出库仓')
        }
      } else {
        this.$message.warning('请先选中网点')
      }
    },

    // 返回列表页
    goBackIndex() {
      this.$emit('goBackIndex')
    },

    // 添加明细
    confirm(data) {
      console.log(data, '明细')
      let temp = this.formData.spPartsApplyLineDTOList
      if (temp == null) {
        temp = []
      }
      data.forEach(item => {
        temp.push({
          partsId: item.id,
          partsCode: item.partsCode,
          partsName: item.partsName,
          sitePrice: item.sitePrice,
          availableQty: item.availableQty ? item.availableQty : 0,   // 计划单可用数量
          applyQty: item.availableQty ? item.availableQty : 1,
          applyAmount: item.price,
          checkQty: 0,
          checkAmount: 0,
          outQty: 0,
          outAmount: 0,
          getQty: 0,
          getAmount: 0,
          diffQty: 0,
          diffAmount: 0,
          getStat: 0,
          selectId: item.id,
          planId: item.planId ? item.planId : null,
          planNo: item.planNo ? item.planNo : null,
          orderNo: item.orderNo ? item.orderNo : null,
          orderId: item.orderId ? item.orderId : null,
          // dontChangQty: false
        })
      })
      this.formData.spPartsApplyLineDTOList = temp
    },

    // 添加明细
    confirm1(data) {
      console.log(data, '明细')
      let temp = this.formData.spPartsApplyLineDTOList
      if (temp == null)
        temp = []
      data.forEach(item => {
        temp.push({
          partsId: item.partsId,
          partsCode: item.partsCode,
          partsName: item.partsName,
          sitePrice: item.sitePrice,
          applyQty: Number(item.waitQty) - Number(item.applyQty),
          applyAmount: item.sitePrice,
          checkQty: 0,
          checkAmount: 0,
          outQty: 0,
          outAmount: 0,
          getQty: 0,
          getAmount: 0,
          diffQty: 0,
          diffAmount: 0,
          getStat: 0,
          selectId: item.id + item.orderId,
          orderNo: item.orderNo ? item.orderNo : null,
          orderId: item.orderId ? item.orderId : null,
          // dontChangQty: true
        })
      })
      this.formData.spPartsApplyLineDTOList = temp
    },

    // 添加明细
    confirm2(data) {
      console.log(data, '明细')
      let temp = this.formData.spPartsApplyLineDTOList
      if (temp == null) {
        temp = []
      }
      data.forEach(item => {
        temp.push({
          partsId: item.partsId,
          partsCode: item.partsCode,
          partsName: item.partsName,
          sitePrice: item.price,
          availableQty: item.availableQty ? item.availableQty : 0,   // 计划单可用数量
          applyQty: item.availableQty ? item.availableQty : 1,
          applyAmount: item.price,
          checkQty: 0,
          checkAmount: 0,
          outQty: 0,
          outAmount: 0,
          getQty: 0,
          getAmount: 0,
          diffQty: 0,
          diffAmount: 0,
          getStat: 0,
          selectId: item.id + item.planId,
          planId: item.planId ? item.planId : null,
          planNo: item.planNo ? item.planNo : null,
          orderNo: item.orderNo ? item.orderNo : null,
          orderId: item.orderId ? item.orderId : null,
          // dontChangQty: false
        })
      })
      this.formData.spPartsApplyLineDTOList = temp
    },


    // 机构数据选中
    commitOrgSelect(data) {
      console.log(data, '机构数据')
      this.formData.orgId = data.id
      this.formData.orgName = data.name
      this.formData.orgIdPath = data.orgIdPath

      this.formData.siteId = null
      this.formData.siteName = null
    },

    // 抽屉关闭
    closeD() {
      this.showAuditDialog = false
      this.showCloseDialog = false
      this.showOutboundDialog = false
      this.showInboundDialog = false
    },


    deleteData() {
      let temp = this.formData.spPartsApplyLineDTOList
      if (!this.selectedData || this.selectedData.length == 0) {
        this.$message.error('请先选中要删除的数据')
        return
      }
      this.selectedData.forEach(item => {
        temp = temp.filter(item1 => item1.selectId != item.selectId)
      })
      this.formData.spPartsApplyLineDTOList = temp
    },
    selectChangeEvent(data) {
      console.log('选中数据', data)
      this.selectedData = data.records
    },


    // 仓库弹框选中
    warehouseCommit(data) {
      console.log('选中的仓库', data)
      this.formData.outWarehouseId = data.warehouseId
      this.formData.outWarehouseName = data.warehouseName
    },


    getSiteData() {
      this.loadOutWarehouse()
      if (!this.formData.siteId) {
        this.formData.deliverProvince = null
        this.formData.deliverCity = null
        this.formData.deliverCounty = null
        this.formData.deliverTown = null
        this.formData.deliverAddress = null
        this.formData.areaId = null

        this.formData.minPartsApplyAmount = 0
        this.formData.deliverMan = null
        this.formData.deliverMobile = null
        this.areaValues = []

      } else {
        // 带出网点数据
        this.$http.post(api.snUser.getDataUrl, {id: this.formData.siteId}).then(res => {
          let siteData = res.data.data;
          console.log(siteData, 'siteData')
          this.setDeliverData(siteData)
          // this.formData.deliverProvince = siteData.userProvince
          // this.formData.deliverCity = siteData.userCity
          // this.formData.deliverCounty = siteData.userCounty
          // this.formData.deliverTown = siteData.userTown
          // this.formData.deliverAddress = siteData.userAddress
          // this.formData.areaId = siteData.areaId
          // this.echoAddress()

          this.maxPartsApplyQty = siteData.snSiteInfoDTO.maxPartsApplyQty
          this.maxPartsApplyAmount = siteData.snSiteInfoDTO.maxPartsApplyAmount

          if (!this.maxPartsApplyQty) {
            this.maxPartsApplyQty = 0
          }
          if (!this.maxPartsApplyAmount) {
            this.maxPartsApplyAmount = 0
          }

          if (this.formData.planType == 2) {
            this.formData.minPartsApplyAmount = siteData.snSiteInfoDTO.minPartsApplyAmountTwo
          } else {
            this.formData.minPartsApplyAmount = siteData.snSiteInfoDTO.minPartsApplyAmount
          }

          if (!this.formData.minPartsApplyAmount) {
            this.formData.minPartsApplyAmount = 0
          }

          // let siteMan = siteData.snSiteInfoDTO.siteMan
          // if (siteMan != null && siteMan != '') {
          //   this.formData.deliverMan = siteMan
          // } else {
          //   this.formData.deliverMan = siteData.userName
          // }
          // this.formData.deliverMobile = siteData.userMobile
        })
        this.formData.spPartsApplyLineDTOList = []

        this.loadPartsBalance()
        this.loadUrgerPartsQty()
      }
    },

    // 获取配件余额
    loadPartsBalance() {
      if (this.formData.stat == 0 || this.formData.stat == 9 || this.formData.stat == 1) {
        if (this.formData.siteId) {
          this.$mask.open()
          this.$http.post(api.partsBalance.getPartsBalanceUrl,
            {id: this.formData.siteId, orderType: this.formData.orderType}
          ).then(res => {
            this.$mask.close()
            let data = res.data.data;
            console.log(this.formData.siteId, data, '获取网点配件余额')
            this.totalBalance = data.totalBalance
            this.liquidBalance = data.liquidBalance
          }).catch(() => {
            this.$mask.close()
            this.totalBalance = 0
            this.liquidBalance = 0
          })
        } else {
          this.totalBalance = 0
          this.liquidBalance = 0
        }
      }
    },

    loadUrgerPartsQty(){
      if(this.formData.siteId){
        this.$mask.open()
        this.$http.post(api.snUser.partsRulesPageUrl,
          {siteId: this.formData.siteId, type: "已设置",current:1,size:1,searchCount: false}
        ).then(res => {
          this.$mask.close()
          let data = res.data.data.records;
          if(data){
            this.urgerPartsQty = data[0].limitUrgerPartsQty-data[0].occupation-data[0].used;
          }else {
            this.urgerPartsQty = 0
          }
        }).catch(() => {
          this.$mask.close()
          this.urgerPartsQty = 0
        })
      }else {
        this.urgerPartsQty = 0
      }
    },

    // 设置收货地址
    setDeliverData(siteData) {
      let list = siteData.snSiteAddressDTOS;
      if (list != null && list.length > 0) {
        list.forEach(item => {
          if (item.addressTypeName === '仓库') {
            this.formData.deliverProvince = item.province
            this.formData.deliverCity = item.city
            this.formData.deliverCounty = item.county
            this.formData.deliverTown = item.town
            this.formData.deliverAddress = item.address
            this.formData.areaId = item.areaId

            this.formData.deliverMan = item.addressMan
            this.formData.deliverMobile = item.addressMobile
          }
        })
      } else {
        this.formData.deliverProvince = siteData.userProvince
        this.formData.deliverCity = siteData.userCity
        this.formData.deliverCounty = siteData.userCounty
        this.formData.deliverTown = siteData.userTown
        this.formData.deliverAddress = siteData.userAddress
        this.formData.areaId = siteData.areaId

        let siteMan = siteData.snSiteInfoDTO.siteMan
        if (siteMan != null && siteMan != '') {
          this.formData.deliverMan = siteMan
        } else {
          this.formData.deliverMan = siteData.userName
        }
        this.formData.deliverMobile = siteData.userMobile
      }
      this.echoAddress()
    },


    // 地址选中事件
    handleChange() {
      const areaNode = this.$refs["cascader"].getCheckedNodes();
      console.log('handleNode', areaNode)
      if (areaNode != null && areaNode[0] != null && areaNode[0].value != null) {
        if (areaNode[0].level == 1) {
          this.formData.country = areaNode[0].label;
          this.formData.deliverProvince = null;
          this.formData.deliverCity = null;
          this.formData.deliverCounty = null;
          this.formData.deliverTown = null;
        } else if (areaNode[0].level == 2) {
          this.formData.deliverProvince = areaNode[0].label;
          this.formData.deliverCity = null;
          this.formData.deliverCounty = null;
          this.formData.deliverTown = null;
        } else if (areaNode[0].level == 3) {
          this.formData.deliverCity = areaNode[0].label;
          this.formData.deliverTown = null;
          this.formData.deliverCounty = null;
        } else if (areaNode[0].level == 4) {
          this.formData.deliverCounty = areaNode[0].label;
          this.formData.deliverTown = null;
        } else if (areaNode[0].level == 5) {
          this.formData.deliverTown = areaNode[0].label;
        }
        this.formData.areaId = areaNode[0].value
      } else {
        this.formData.areaId = null;
        this.formData.country = null;
        this.formData.deliverProvince = null;
        this.formData.deliverCity = null;
        this.formData.deliverCounty = null;
        this.formData.deliverTown = null;
      }

      const panelRefs = this.$refs.cascader.$refs.panel
      if (panelRefs.activePath.length !== 0) {
        panelRefs.lazyLoad(panelRefs.getCheckedNodes()[0])
      }

    },

    // 地址懒加载
    cascaderLazyLoad(node, resolve) {
      if (!node) {
        return false
      }
      this.$http({
        url: api.basArea.getList,
        method: 'post',
        data: {
          parentId: node.value
        },
        isLoading: true,
        modalStrictly: true,
      }).then(response => {
        if (node.root) {
          const childrens = response.data.data || {};
          const childNodes = childrens.map(item => ({
            value: item.id,
            label: item.areaName,
            leaf: Number(item.hasChild) !== 0
          }))
          console.log('childNodes', childNodes)
          // 通过调用resolve将子节点数据返回，通知组件数据加载完成
          resolve(childNodes);
        } else {
          const childrens = response.data.data || {};
          let childNodes = []
          let temp = ''
          console.log(node.children, 'child')
          if (node.children.length !== 0) {
            temp = node.children
            childrens.forEach(item => {
              let flag = false
              temp.forEach(item1 => {
                if (item1.value == item.id) {
                  flag = true  // 当前节点已存在此数据，不追加
                }
              })
              if (!flag) {
                childNodes.push({
                  value: item.id,
                  label: item.areaName,
                  leaf: Number(item.hasChild) !== 0
                })
              }
            })
            resolve(childNodes);
          } else {
            childrens.forEach(item => {
              childNodes.push({
                value: item.id,
                label: item.areaName,
                leaf: Number(item.hasChild) !== 0
              })
            })
            resolve(childNodes);
          }
        }
      })
    },

    // 地址数据回显
    echoAddress() {
      if (this.formData.areaId && this.formData.areaId != 0) {
        this.$http.post(api.basArea.echoAddressUrl, {id: this.formData.areaId}).then(res => {
          console.log(res)
          this.areaOption = res.data.data.options
          this.areaValues = res.data.data.values
          this.area = res.data.data.names
        })
      }
    },

    checkEnableBalance() {
      this.$http.post('/admin/fwpttenant/checkEnableBalance', {}).then(res => {
        this.enableBalance = res.data.data
      })
    },

    saveData() {
      if (!this.formData.orderType) {
        this.$message.error('请先选中订单类型')
        return;
      }
      if (!this.formData.domesticShippingType) {
        this.$message.error('请先选中运费方式')
        return;
      }
      if (!this.formData.areaId) {
        this.$message.error('请先选择地区')
        return;
      }
      if (!this.formData.deliverAddress) {
        this.$message.error('请先填写详细地址')
        return;
      }
      if (!this.formData.applyAmountIsPrint) {
        this.$message.error('请选择是否打印[发货单价格]')
        return;
      }
      if (this.formData.domesticShippingType == 1) {
        console.log('this.maxPartsApplyQty'+this.maxPartsApplyQty)
        console.log('this.formData.applyQtyAll'+this.formData.applyQtyAll)
        console.log('this.maxPartsApplyAmount'+this.maxPartsApplyAmount)
        console.log('this.formData.applyAmountAll'+this.formData.applyAmountAll)


        if (this.formData.applyType==2) {
          if (this.maxPartsApplyQty != 0) {
            if (Number(this.maxPartsApplyQty) < Number(this.formData.applyQtyAll)) {
              this.$message.error('不允许选择总部包邮、只能选择自付运费')
              return;
            }
          }
        }

        if (this.formData.applyType==1) {
          if (this.maxPartsApplyAmount != 0) {
            if (Number(this.maxPartsApplyAmount) < Number(this.formData.applyAmountAll)) {
              this.$message.error('不允许选择总部包邮、只能选择自付运费')
              return;
            }
          }
        }
      }


      // 改为提交审核判断
      // if (this.formData.orderType != 3) {
      //   if (this.formData.applyAmountAll < this.formData.minPartsApplyAmount) {
      //     this.$message.error('总申请金额需大于最小申请金额')
      //     return
      //   }
      // }

      if (this.formData.orderType != 3) {
        if (this.enableBalance) {
          if(this.formData.orderType==2) {
            if (Number(this.totalBalance) < Number(this.formData.applyAmountAll)) {
              this.$message.error('网点配件余额不足')
              return
            }
          }else if(this.formData.orderType==1){
            if (Number(this.liquidBalance) < Number(this.formData.applyAmountAll)) {
              this.$message.error('网点配件余额不足')
              return
            }
          }
        } else {
          // if (Number(this.partsBalance) < Number(this.formData.applyAmountAll)) {
          //   this.$message.error('网点配件余额不足')
          // }
        }
      }


      // if (this.formData.spPartsApplyLineDTOList == null || this.formData.spPartsApplyLineDTOList.length === 0) {
      //   this.$message.error('请添加明细')
      //   return
      // }

      const rules = {
        orgId: [{prop: '所属机构', required: true,}],
        orgName: [{prop: '所属机构', required: true, type: 'string', maxlength: 30,}],
        orgIdPath: [{prop: '所属机构', required: true, type: 'string', maxlength: 50,}],
        siteId: [{prop: '网点', required: true,}],
        stat: [{prop: '单据状态', required: true, type: 'number', max: 99,}],
        orderType: [{prop: '订单类型', required: true, type: 'number', max: 99,}],
        planType: [{prop: '计划类型', required: true, type: 'number', max: 99,}],
        itemType: [{prop: '物资类型', required: true, type: 'number', max: 99,}],
        // feeType: [{prop: '费用类型', required: false, type: 'number', max: 99,}],
        applyType: [{prop: '申请类型', required: false, type: 'number', max: 99,}],
        outType: [{prop: '发出类型', required: true, type: 'number', max: 99,}],
        applyAmountAll: [{prop: '总申请金额', required: true, type: 'number', max: 999999.99,}],
        outWarehouseId: [{prop: '出库仓', required: true,}],
        deliverProvince: [{prop: '省', required: false, type: 'string', maxlength: 30,}],
        deliverCity: [{prop: '市', required: false, type: 'string', maxlength: 30,}],
        deliverCounty: [{prop: '区', required: false, type: 'string', maxlength: 30,}],
        deliverTown: [{prop: '街道', required: false, type: 'string', maxlength: 30,}],
        spPartsApplyLineDTOList: [{
          prop: '配件明细', required: false, type: 'list', rules: {
            applyQty: [{prop: '申请数量', required: true, type: 'number'}]
          }
        }]
      }

      this.$validate(this.formData, rules).then(() => {
        this.$baseConfirm('您确定要保存吗？').then(() => {
          this.$mask.open()


          var url = (this.isEdit ? api.spPartsApplyHeader.updateDataUrl : api.spPartsApplyHeader.addDataUrl);
          this.$http.post(url, this.formData).then(response => {
            this.$message.success("保存成功！");
            this.goBackIndex()
            this.$mask.close()

          }).catch(() => {
            this.$message.error("保存失败！");
            this.$mask.close()
          });
          ;
        });
      })
    },

    getData() {
      console.log('getData')
      if (this.dataId && !isNaN(this.dataId)) {
        this.isEdit = true;
        this.$mask.open()
        this.$http.post(api.spPartsApplyHeader.getDataUrl, {id: this.dataId}).then(response => {
          let data = response.data.data
          data.spPartsApplyLineDTOList.forEach(item => {
            item.selectId = item.id
            if (data.planType == 1)
              item.availableQty = item.applyQty
          })

          if (!this.maxPartsApplyQty) {
            this.$http.post(api.snUser.getPartsNeedDataUrl, {id: data.siteId}).then(res => {
              this.maxPartsApplyQty = res.data.data.maxPartsApplyQty
              this.maxPartsApplyAmount = res.data.data.maxPartsApplyAmount

              if (!this.maxPartsApplyQty) {
                this.maxPartsApplyQty = 0
              }
              if (!this.maxPartsApplyAmount) {
                this.maxPartsApplyAmount = 0
              }
            })
          }

          if (data.spPartsApplyOperationDTOList === null || data.spPartsApplyOperationDTOList === undefined) {
            data.spPartsApplyOperationDTOList = []
          }
          this.formData = data
          this.justShow = !(this.formData.stat == 0 || this.formData.stat == 9)
          if (this.formData.stat == 1 && !this.currentIsSite) {
            this.justShow = false
          }
          this.loadOutWarehouse()
          if (this.justShow) {
            this.showPhotoList = [data.pic1, data.pic2, data.pic3]
          } else {
            this.orgValue = data.orgId
            this.echoAddress()
          }
          this.loadPartsBalance()
          this.$mask.close()
        }).catch(res => {
          this.$mask.close()
        })
      }
    },

    // 修改关联配件
    changeParts(row) {
      console.log(row, 'row')
      this.currentRowData = row
      this.showPartsPop = true
    },

    // 添加关联工单
    addOrderNo(row) {
      console.log(row, 'row')
      this.currentRowData = row
      this.showOrderPop = true
    },

    handleClick(tab, event) {
      console.log(tab, event);
      console.log(tab.name, "name得值");
      if (tab.index == 0) {
        this.card = true
      } else {
        this.card = false
      }


    },
    getCompanyMsg() {
      request({
        url: '/basic/soOrderIssue/getCompanyMsg',
        method: 'post',
        isLoading: true,
        modalStrictly: true,
      }).then(response => {
        this.companyShortName = response.data.data.companyShortName
      })
    },

  },
};
</script>
<style lang="scss" scoped>
#containt .detail-wrap .d-header {
  margin: -6px 0px 0 -12px !important;
  display: flex;
  width: 100%;
  flex-direction: row;
  justify-content: space-between;
}

.el-cascader-panel {
  .el-radio__inner {
    border: 0px;
    background: transparent;
  }

  .el-radio__input.is-checked .el-radio__inner {
    background: none;
  }

  .el-radio {
    height: 100%;
    width: 150px;
    position: absolute;
    z-index: 10;
  }
}

.header_dialog {
  border-radius: 8px !important;
  height: 800px !important;
}

el-dialog {
  border-radius: 8px !important;
  box-shadow: 0 0 24px rgb(0 0 0 / 22%) !important;
}

v::deep .el-upload .el-upload--picture-card {
  position: relative;
  left: -200px;
}

// 单选框
.radio_item {
  width: 24%;
  margin-top: 10px;
  margin-bottom: 10px !important;

  > span {
    display: inline-block;
    width: 120px;
    margin-right: 13px;
    text-align: right;
    font-weight: 400;
    color: rgba(86, 86, 86, 0.96);
    font-size: 12px;
  }
}

.firm {
  .el-input {
    width: 150px;
  }
}

.type_title {
  font-weight: 400;
  text-align: right;
  width: 112px;
  position: relative;
  padding: 0 10px 0 4px;
  color: rgba(86, 86, 86, 0.96);
  font-size: 12px;
}

.type_select {
  width: 120px;
  text-align: center;
}

.type_brand {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  flex-wrap: wrap;

  > div {
    margin: 16px 0;
    width: 25%;
  }
}

// 备注的样式
.annotate {
  padding: 0px !important;
  height: 28px !important;
  min-height: 28px !important;
}

.el-textarea__inner {
  padding: 0px !important;
  height: 28px !important;
  min-height: 28px !important;
}

// 装图片的  大框
::v-deep.table-detail .el-upload--picture-card {
  // margin-top: 10px;
  width: 40px;
  height: 40px;
  line-height: 50px !important;
}

::v-deep .el-upload-list .el-upload-list__item {
  display: inline-block;
  width: 80px;
  height: 40px;
  margin-right: 14px;
  border-radius: 2px;
  padding: 0 !important;
  border-color: #e8e8e8;
  margin-top: 0;
  margin-bottom: 10px;
}

::v-deep .el-upload-list .el-upload-list__item .el-upload-list__item-thumbnail {
  width: 80px;
  height: 40px;
  padding: 0 !important;
  position: inherit;
  cursor: pointer;
}

::v-deep.el-upload-list__item.is-success .el-upload-list__item-status-label {
  display: none !important;
}

// 输入框的宽度
// #containt .table-detail tbody tr td .el-input {
//   width: 100% !important;
//   width: 0 !important;
// }

// Switch 开关  标题的宽度
.el-switch__label * {
  line-height: 1;
  width: 160px !important;
  display: inline-block;
  font-weight: 400;
  color: rgba(86, 86, 86, 0.96);
  font-size: 12px;
}

// 清楚表格 默认padding
.el-table--medium .el-table__cell {
  padding: 0px 0 !important;
}

.table_item {
  .el-table__row:hover > td {
    background-color: #D4E7FF !important;
  }
}

.pic_item {

  .el-upload--picture-card {
    margin-top: 1px;
    width: 36px !important;
    height: 36px !important;
    line-height: 46px !important;
  }
}

// 卡片样式
.card_item {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;


  .el-card__header {
    padding: 10px 20px 5px;
    border-bottom: 1px dashed #7a7e7c;
    font-weight: 600;
    font-size: 13px;
  }

  .el-card__body,
  .el-main {
    padding: 10px 20px;
  }

  .text {
    font-size: 12px;
  }

  .item {
    margin-bottom: 12px;
    display: block;
  }

  .clearfix:before,
  .clearfix:after {
    display: table;
    content: "";
  }

  .clearfix:after {
    clear: both
  }

  .box-card {
    width: 30%;
    margin-right: 30px;
    margin-bottom: 30px;
    border: 1px solid #ccc !important;
  }
}

.papers {
  margin-left: 30px;
  position: absolute;

  ::v-deep.el-upload-list .el-upload-list__item {
    display: inline-block;
    width: 147px !important;
    margin-right: 14px;
    border-radius: 2px;
    border-color: #e8e8e8;
    margin-top: 7px;
    margin-left: 15px;
    padding: 0px !important;
    background-color: #e1e1e1;
    height: 20px;
  }

}

::v-deep .btn_zdy {
  margin: 0 !important;
  border: 1px solid #dcdfe6 !important;
  border-color: #dcdfe6 !important;
  color: #606266 !important;
  font-weight: 400;
  text-align: center;
  background-color: #FBFBFB !important;
}

.btn_zdy:hover {
  color: #00c4b3 !important;
  border: 1px solid #00c4b3 !important;
}

.btn_zdy2 {
  // 选取文件合同按钮
  // margin: 10px 60px;
  margin-top: 6px;
  border: 1px solid #dcdfe6 !important;
  border-color: #dcdfe6 !important;
  color: #606266 !important;
  font-weight: 400;
  text-align: center;
  background-color: #FBFBFB !important;
}

.btn_zdy2:hover {
  color: #00c4b3 !important;
  border: 1px solid #00c4b3 !important;
}

::v-deep .el-tabs__header {
  padding: 0;
  position: relative;
  margin: 0 0 0 0px !important;
}

// 步骤条
::v-deep .el-card__body,
.el-main {
  padding: 0px !important;
  font-size: 12px;
}

.task {
  color: #62f382;
}

.card {
  padding: 0px 5px;
  background-color: #efefef;
}

.el-timeline {
  margin-top: 40px;
  margin: 0;
  list-style: none;
  margin-left: 6px;
  border: 1px solid #fbfbfb;
  padding-top: 12px;
  height: 72.5vh;
  overflow-y: scroll;
  background-color: #f2f2f2;
  padding-left: 10px !important;
}

.title_icon1 {
  display: inline-block;
  background: rgba(42, 100, 148, 0.16);
  width: 19px;
  background-color: #409EFF;
  color: #fff;
  text-align: center;
  margin-bottom: 15px;
}

.title_icon {
  display: inline-block;
  background: rgba(42, 100, 148, 0.16);
  width: 19px;
  background-color: #00c4b3;
  color: #fff;
  text-align: center;
  margin-bottom: 15px;
}

::v-deep .el-timeline-item__node {
  background-color: #ffffff !important;
  border: 1px solid #0550ef;
}

.bread {
  span {
    color: rgba(86, 86, 86, 0.96) !important;
  }

  ::v-deep .el-collapse-item__content {
    padding-bottom: 0px;
    background-color: #efefef;

  }
}

.card_bread {
  position: relative !important;
}

::v-deep .el-tabs__content {
  overflow: visible !important;

}

#containt .detail-wrap .d-cont {
  overflow: unset !important;
}

// .el-timeline-item {
//   position: relative;
//   padding-bottom: 0px !important;
//   margin-left: 47px;
// }
.el-timeline-item[data-v-2cf56cc1] {
  position: relative;
  margin-left: 5px;
  padding-bottom: 0px !important;
}

// 滚动条样式

/* 滚动条 */
::-webkit-scrollbar {
  width: 5px;
  height: 12px;
}

/* 滚动槽 */
::-webkit-scrollbar-track {
  border-radius: 0px;
  // background: rgba(224, 7, 7, 0.05);
}

/* 滚动条滑块 */
::-webkit-scrollbar-thumb {
  border-radius: 00px;
  background: #cfcece;
}

// 步骤条 圆的位置
::v-deep .el-timeline-item__node--normal {
  left: 0px !important;
  width: 12px;
  height: 12px;
}

.el-timeline[data-v-2cf56cc1] {
  position: relative !important;
}

#containt .detail-wrap .d-cont .d-item {
  border: solid 1px #e9e9e9;
  padding: 0 12px 6px;
  position: relative !important;
}

::v-deep .el-collapse-item__arrow {
  position: absolute !important;
  top: 12px !important;
  right: 0 !important;
  font-size: 18px;
  color: #00c4b3 !important;
}

::v-deep .el-collapse-item__content {
  padding-bottom: 0px !important;
}

// 本单费用位置
.expense {
  position: absolute;
  right: 20%;
  margin-top: 5px;
  color: #00c4b3;
  font-size: 13px;
}

::v-deep .el-image__preview {
  width: 60px !important;
  height: 60px !important;
}

.pic_main {
  display: flex;
  margin-left: 75px;
  margin-top: 10px;

  .pic_item {
    display: flex;
    margin-right: 40px;

    span {
      line-height: 60px;
      font-size: 12px;
      color: rgba(86, 86, 86, 0.96);
      font-weight: 400;

    }
  }
}

// 步骤条
.el-steps--simple {
  margin: 20px 0 6px;
}

.el-step.is-simple {
  width: 225px;
}

.audit {
  span {
    font-size: 12px;
    color: rgba(86, 86, 86, 0.96);
    font-weight: 400;
  }
}

// 卡片样式
.card_item {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;


  .el-card__header {
    padding: 10px 20px 5px;
    border-bottom: 1px dashed #7a7e7c;
    font-weight: 600;
    font-size: 13px;
  }

  .el-card__body,
  .el-main {
    padding: 10px 20px;
  }

  .text {
    font-size: 12px;
  }

  .item {
    margin-bottom: 12px;
    display: block;
  }

  .clearfix:before,
  .clearfix:after {
    display: table;
    content: "";
  }

  .clearfix:after {
    clear: both
  }

  .box-card {
    width: 30%;
    margin-right: 30px;
    margin-bottom: 30px;
    border: 1px solid #ccc !important;
  }
}

// 折叠样式对其
// .table-detail {
//   tr{
//     display:block;
//   }
// }
#containt .table-detail tbody tr th {
  display: table-cell;
  vertical-align: middle;
}

#containt .table-detail tbody tr td {

  display: table-cell;
  vertical-align: middle;
}

.title_time {
  margin-top: -13px;
  font-size: 12px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;

  .span1 {
    color: #00c4b3 !important;
    width: 35%;
    display: inline-block;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .span2 {
    margin-right: 20px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

}


// 字段之间的距离
#containt .table-detail tbody tr td {
  padding: 5px 12px;
  width: 14vw;
  height: 27.2px !important;
  word-break: break-word;
}

.information {
  padding: 4px 10px;
  background-color: #E1F2FF;
  color: #268AEA;
  border-radius: 3px;
  margin: 0 5px;
}

#containt .table-detail tbody tr th {
  width: 6vw !important;
}


::v-deep .el-step__title {
  font-size: 11px;
  line-height: 25px;
}

#containt .table-detail tbody tr th {
  width: 6vw !important;
}

#containt .table-detail tbody tr td[data-v-7297c694] {
  padding: 5px 12px;
  width: 11vw !important;
  height: 27.2px !important;
  word-break: break-word;
}

::v-deep .el-image {
  margin-right: 15px;
}

::v-deep .product th:after {
  display: none !important;
}

::v-deep .product td {
  padding: 5px 0 !important;

}

::v-deep .el-tabs__content {
  padding-top: 10px;
  height: 125px;
  overflow: hidden !important;
  overflow-y: scroll !important;
}
</style>
